import InitialContext from '../state/static-data/InitialContext'

export const isTreatmentT1 = (weblabName: string) => InitialContext.getWeblabTreatments()[weblabName] === 'T1';

export const CDP_GET_STARTED_BUTTON_WEBLAB = "CLINIC_633155"
export const CLINIC_CDP_CURRENT_ASIN_DECOUPLE_TWISTER_OFFER_INFO = "CURRENT_ASIN_DECOUPLE_TWISTER_OFFER_INFO_WEBLAB_TREATMENT";
